import React from 'react';
import { connect } from 'react-redux';

import { Form } from 'components/common';
import MainFieldSet from './MainFieldSet';

const WarehouseForm = (props) => {
  const { showEditForm } = props.warehouse;

  const onClose = () => {
    props.actions.warehouse.showEditForm({ show: false });
  };

  const onSubmit = (data) => {
    const newData = Object.assign(data, {
      site: props.site.activeId,
    });
    props.actions.warehouse.update(newData);
  };

  return (
    <Form
      title="Редактирование свойства"
      model={props.warehouse}
      visible={showEditForm}
      onClose={onClose}
      onSubmit={onSubmit}
      initialValues={{ sort: 100 }}
    >
      <MainFieldSet {...props} />
    </Form>
  );
};

const mapState = (state) => ({
  site: state.site,
  warehouse: state.warehouse,
});

const mapDispatch = (dispatch) => ({
  actions: {
    warehouse: dispatch.warehouse,
  },
});

export default connect(mapState, mapDispatch)(WarehouseForm);
